// Prijs-conventie voor artikels:
// - art.prijzen[groep] en art.aankoopprijs zijn PER STUK (default).
// - Bij eenheid='pack' is de verkochte eenheid een pak → lijnprijs = stukprijs × pack_grootte,
//   TENZIJ art.prijs_basis === 'pack': dan is de ingevoerde prijs al de pakprijs (stukprijs = ÷ pack_grootte).
const num = (v) => { const f = parseFloat(v); return isNaN(f) ? 0 : f; };
const r2 = (v) => Math.round(v * 100) / 100;

export const isPackArt = (a) => a?.eenheid === 'pack' && num(a?.pack_grootte) > 0;
export const prijsPerPak = (a) => isPackArt(a) && a?.prijs_basis === 'pack';

export const artikelVoorVariant = (article, variant) => {
  if (!variant) return article;
  const packSize = num(variant.pack_grootte) || num(article.pack_grootte);
  const samePieceUnit = article.eenheid === 'pack' && num(article.eenheid_aantal) === num(article.pack_grootte);
  return { ...article, pack_grootte: packSize,
    eenheid_aantal: num(variant.eenheid_aantal) || (samePieceUnit ? packSize : article.eenheid_aantal),
    eenheid_label: variant.eenheid_label ?? article.eenheid_label };
};

// Lijnprijs (per verkochte eenheid) obv een ingevoerde prijs uit art.prijzen / variant-override
export const lijnPrijsVan = (a, ingevoerd) => {
  const p = num(ingevoerd);
  if (!isPackArt(a) || prijsPerPak(a)) return r2(p);
  return r2(p * num(a.pack_grootte));
};

// Stukprijs obv een ingevoerde prijs
export const stukPrijsVan = (a, ingevoerd) => {
  const p = num(ingevoerd);
  if (!isPackArt(a) || !prijsPerPak(a)) return p;
  return p / num(a.pack_grootte);
};

// Multiplier aankoopprijs → kost per verkochte eenheid (winstberekening; zelfde als backend `_art_aankoop_mult`)
export const aankoopMult = (a) => {
  if (a?.prijs_basis === 'pack') return 1;
  const eenheid = a?.eenheid || '';
  const m = ['st', 'stuk', 'stuks', ''].includes(eenheid) ? 0 : num(a?.pack_grootte);
  return m > 0 ? m : 1;
};
